export const mockCircle = [
  [
    { name: 'desligada', value: 500 },
    { name: 'funcionando', value: 500 },
    { name: 'alarmado', value: 500 },
    { name: 'alarme', value: 100 },
    { name: 'Erro', value: 200 },
  ],
  [
    { name: 'desligada', value: 900 },
    { name: 'funcionando', value: 900 },
    { name: 'alarmado', value: 900 },
    { name: 'alarme', value: 0 },
    { name: 'Erro', value: 100 },
  ],
  [
    { name: 'desligada', value: 250 },
    { name: 'funcionando', value: 250 },
    { name: 'alarmado', value: 250 },
    { name: 'alarme', value: 450 },
    { name: 'Erro', value: 300 },
  ],
  [
    { name: 'desligada', value: 333 },
    { name: 'funcionando', value: 333 },
    { name: 'alarmado', value: 333 },
    { name: 'alarme', value: 333 },
    { name: 'Erro', value: 333 },
  ],
  [
    { name: 'desligada', value: 500 },
    { name: 'funcionando', value: 500 },
    { name: 'alarmado', value: 500 },
    { name: 'alarme', value: 100 },
    { name: 'Erro', value: 200 },
  ],
  [
    { name: 'desligada', value: 900 },
    { name: 'funcionando', value: 900 },
    { name: 'alarmado', value: 900 },
    { name: 'alarme', value: 0 },
    { name: 'Erro', value: 100 },
  ],
  [
    { name: 'desligada', value: 250 },
    { name: 'funcionando', value: 250 },
    { name: 'alarmado', value: 250 },
    { name: 'alarme', value: 450 },
    { name: 'Erro', value: 300 },
  ],
  [
    { name: 'desligada', value: 333 },
    { name: 'funcionando', value: 333 },
    { name: 'alarmado', value: 333 },
    { name: 'alarme', value: 333 },
    { name: 'Erro', value: 333 },
  ],
];
